import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { AssetHierarchyComponent } from "./asset-hierarchy.component";
import { AssetHierarchyService } from "../services/asset-hierarchy.service";
import { SharedModule } from "../shared.module";

@NgModule({
  declarations: [AssetHierarchyComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [AssetHierarchyService],
  exports: [AssetHierarchyComponent],
})
export class AssetHierarchyModule {}
